import { observable, computed } from 'mobx'

import Connection from './connection'
import PaginatedStore from './paginated_store'
import api from '../api'

export default class WebsitesStore extends PaginatedStore {
  @observable pendingCount

  constructor(scope) {
    super(new Connection('websites', scope))
    this.recountPending()
  }

  async recountPending() {
    const resp = await this.connection.load(null, { status: 'pending', page: 1, per_page: 1 } )
    this.pendingCount = resp.data.meta.total_count
  }

  revoke(website_id) {
    return api.put(`websites/${website_id}`, { installation_uuid: null, status: 'revoked' })
      .then(() => {
        const website = this.findById(website_id)
        website.provisioned = false
        website.pending = false
        website.active = false
        website.revoked = true
        website.status = 'revoked'
        this.recountPending()
      })
  }

  activate(website_id) {
    return api.put(`websites/${website_id}`, { status: 'active' })
      .then(() => {
        const website = this.findById(website_id)
        website.revoked = false
        website.pending = false
        website.active = true
        website.status = 'active'
        this.recountPending()
      })
  }

  @observable mls_permissions

  @computed get mlsPermissionsLoaded() {
    return this.mls_permissions !== undefined
  }

  loadMlsPermissions(website_id) {
    return api.get('mls_permissions', { params: { website_id } })
      .then(resp => resp.data)
      .then(data => this.mls_permissions = data)
  }

  createMlsPermission(params = {}) {
    return api.post('mls_permissions', params)
      .then(resp => resp.data)
      .then(data => this.mls_permissions.push(data))
  }

  editMlsPermission(id, params = {}) {
    const record = this.mls_permissions.find(m => m.id === id)

    return api.put(`mls_permissions/${id}`, params)
      .then(() => Object.keys(params).forEach(key => record[key] = params[key]))
  }

  deleteMlsPermission(id) {
    return api.delete(`mls_permissions/${id}`)
      .then(() => this.mls_permissions.remove(this.mls_permissions.find(m => m.id === id)))
  }
}



// WEBPACK FOOTER //
// client/stores/websites.js